import React, { FC, useState, useCallback } from 'react';
import { ResponseArtifactDTO } from '@dreamai/types';
import { OnboardingModal } from '../../onboarding/OnboardingModal';
import { useOnboardingModals } from '../../../providers';
import './research-still-there-modal.scss';

interface ResearchStillThereModalProps {
  show: boolean;
  artifact: ResponseArtifactDTO | null;
  onClose: () => void;
  onConfirm: (artifact: ResponseArtifactDTO) => void;
}

const ResearchStillThereModal: FC<ResearchStillThereModalProps> = ({
  show,
  artifact,
  onClose,
  onConfirm,
}) => {
  const { markAsSeen } = useOnboardingModals();
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handlePrimaryClick = useCallback(async () => {
    if (dontShowAgain) {
      markAsSeen('dismiss_blank_todo_research_warning').catch(() => {});
    }
    if (artifact) {
      onConfirm(artifact);
    }
    // Note: OnboardingModal will call onClose after onPrimaryClick completes
  }, [dontShowAgain, markAsSeen, artifact, onConfirm]);

  const handleClose = useCallback(() => {
    setDontShowAgain(false);
    onClose();
  }, [onClose]);

  return (
    <OnboardingModal
      modalKey='dismiss_blank_todo_research_warning'
      title='Your research is still there'
      imageSrc='/onboarding-modals/research-still-there.png'
      primaryButtonText='Ok, got it'
      controlled
      show={show}
      onClose={handleClose}
      onPrimaryClick={handlePrimaryClick}
    >
      <p>
        Need to find your research again? You'll find it all on the research tab
        in 'Your Tasks'.
      </p>
      <div className='dont-show-again-rsm'>
        <label className='checkbox-label'>
          <input
            type='checkbox'
            checked={dontShowAgain}
            onChange={(e) => setDontShowAgain(e.target.checked)}
          />
        </label>
        <span>Don't show this message again</span>
      </div>
    </OnboardingModal>
  );
};

export default ResearchStillThereModal;
